<div class="catalog-container">
  <div>
    <h1>I'm not sure what goes here...</h1>
  </div>
  <div class="no-courses">
  </div>
</div>
